var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42654_2644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45217 1.60456C8.11228 0.967009 8.99638 0.614228 9.91407 0.622203C10.8318 0.630177 11.7096 0.998268 12.3585 1.6472C13.0075 2.29613 13.3756 3.17397 13.3835 4.09166C13.3915 5.00935 13.0387 5.89345 12.4012 6.55356C12.3952 6.55972 12.3891 6.56575 12.3829 6.57164L11.4846 7.4233C11.2508 7.64495 10.8816 7.6351 10.6599 7.4013C10.4383 7.1675 10.4481 6.79828 10.6819 6.57663L11.5704 5.73431C11.9901 5.2952 12.2222 4.70954 12.2169 4.10179C12.2116 3.49 11.9662 2.90477 11.5336 2.47215C11.101 2.03954 10.5157 1.79414 9.90394 1.78883C9.29347 1.78352 8.7053 2.01768 8.26554 2.44096L7.26536 3.43533C7.03689 3.66247 6.66755 3.66139 6.44041 3.43292C6.21326 3.20445 6.21434 2.83511 6.44281 2.60797L7.44614 1.61047L7.45217 1.60456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51487 12.3954C5.85476 13.033 4.97066 13.3858 4.05297 13.3778C3.13528 13.3698 2.25743 13.0017 1.60851 12.3528C0.959578 11.7039 0.591486 10.826 0.583512 9.90834C0.575538 8.99065 0.928318 8.10654 1.56587 7.44644C1.57182 7.44028 1.57791 7.43425 1.58412 7.42835L2.48246 6.5767C2.71626 6.35505 3.08547 6.3649 3.30712 6.5987C3.52877 6.8325 3.51892 7.20172 3.28512 7.42337L2.39663 8.26568C1.97691 8.7048 1.74485 9.29046 1.75013 9.8982C1.75545 10.51 2.00084 11.0952 2.43346 11.5278C2.86608 11.9605 3.45131 12.2059 4.06311 12.2112C4.67357 12.2165 5.26174 11.9823 5.7015 11.559L6.70168 10.5647C6.93015 10.3375 7.2995 10.3386 7.52664 10.5671C7.75378 10.7955 7.7527 11.1649 7.52423 11.392L6.5209 12.3895L6.51487 12.3954Z",
    fill: "black",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92759 1.91408C2.1591 1.69004 2.5284 1.69609 2.75244 1.9276L11.5024 10.9693C11.7265 11.2008 11.7204 11.5701 11.4889 11.7941C11.2574 12.0182 10.8881 12.0121 10.6641 11.7806L1.91407 2.73892C1.69003 2.50741 1.69608 2.13812 1.92759 1.91408Z",
    fill: "black",
    fillOpacity: 0.76
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42654_2644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.e6f2985bc7106d98eb18ce3d1f974118.svg";
export { ForwardRef as ReactComponent };